import { useEffect, useState } from "react";

const KEY = "lab-console:last-chat";
const listeners = new Set<() => void>();

export function getLastChatId(): string | null {
  try {
    const v = localStorage.getItem(KEY);
    return v ? v : null;
  } catch {
    return null;
  }
}

export function setLastChatId(id: string | null) {
  try {
    if (!id) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, id);
  } catch {
    /* private mode — remembering is a nicety */
  }
  for (const fn of listeners) fn();
}

export function chatNavTo(): string {
  const id = getLastChatId();
  return id ? `/chat/${id}` : "/chat";
}

/** Subscribe so the Chat entry href updates when a conversation is opened. */
export function useChatNavTo(): string {
  const [to, setTo] = useState(chatNavTo);
  useEffect(() => {
    const fn = () => setTo(chatNavTo());
    listeners.add(fn);
    fn();
    return () => {
      listeners.delete(fn);
    };
  }, []);
  return to;
}
